// ===========================================================================
// ReHome — Centralized cross-app URL configuration
// ---------------------------------------------------------------------------
// Single source of truth for the three ReHome web apps' URLs. Resolved from
// Vite build-time env vars (see each frontend's `.env` / `.env.production`),
// with local-dev ports as fallback.
//
// Do NOT hardcode app URLs anywhere else — import `appUrls` from here instead.
//
//   Production (see .env.production):
//     landing   → https://rehome-landing.tech4tails.eu
//     platform  → https://rehome-platform.tech4tails.eu
//     shelter   → https://rehome-admin.tech4tails.eu
//
//   Local dev (vite server ports):
//     landing 3000 · platform 3001 · shelter 4002
// ===========================================================================

const env = (typeof import.meta !== 'undefined' ? (import.meta as any).env : undefined) ?? {};

/** Strip trailing slashes so `${url}/animals` never produces a double slash. */
const clean = (url: string): string => url.replace(/\/+$/, '');

export const appUrls = {
  /** Public landing page (rehome-landing). */
  landing: clean(env.VITE_LANDING_URL || 'http://localhost:3000'),
  /** Adopter / donor platform (rehome-platform). */
  platform: clean(env.VITE_PLATFORM_URL || 'http://localhost:3001'),
  /** Shelter admin console (rehome-admin). */
  shelter: clean(env.VITE_SHELTER_URL || 'http://localhost:4002'),
} as const;

export type AppUrls = typeof appUrls;
